import React from "react";
import { Link } from "react-router-dom";
import { all_routes } from "../../router/all_routes";

const TeacherMenu = () => {
  const routes = all_routes;

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          {/* Header */}
          <div className="row mb-4">
            <div className="col">
              <h3 className="page-title mb-2">Teacher Menu</h3>
              <p className="text-muted mb-0">
                Access all teacher tools and features
              </p>
            </div>
          </div>

          {/* Profile Section */}
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title mb-0">Profile Section</h5>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <Link
                    to="/teacher/profile"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-primary-transparent me-3">
                      <i className="ti ti-user text-primary"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">View Profile</h6>
                      <p className="text-muted mb-0">
                        Personal information & bio
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/settings"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-secondary-transparent me-3">
                      <i className="ti ti-settings text-secondary"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Account Settings</h6>
                      <p className="text-muted mb-0">Privacy & preferences</p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Daily & Academic Pages */}
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title mb-0">Daily & Academic Pages</h5>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <Link
                    to={routes.teachersRoutine}
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-info-transparent me-3">
                      <i className="ti ti-calendar text-info"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Full Schedule</h6>
                      <p className="text-muted mb-0">Weekly, filterable</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/attendance-history"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-success-transparent me-3">
                      <i className="ti ti-calendar-check text-success"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Attendance History</h6>
                      <p className="text-muted mb-0">Past attendance records</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/homework-history"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-warning-transparent me-3">
                      <i className="ti ti-book text-warning"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Homework History</h6>
                      <p className="text-muted mb-0">
                        Previously assigned tasks
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/grades-overview"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-purple-transparent me-3">
                      <i className="ti ti-clipboard-list text-purple"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Grades / Exam Overview</h6>
                      <p className="text-muted mb-0">
                        Student performance data
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/announcements-sent"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-cyan-transparent me-3">
                      <i className="ti ti-bell text-cyan"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Announcements Sent</h6>
                      <p className="text-muted mb-0">Message history</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/students-directory"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-indigo-transparent me-3">
                      <i className="ti ti-users text-indigo"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Students Directory</h6>
                      <p className="text-muted mb-0">Organized by class</p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Administrative Tools */}
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title mb-0">Administrative Tools</h5>
            </div>
            <div className="card-body">
              <div className="row g-3">
                <div className="col-md-6">
                  <Link
                    to="/teacher/report-student"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-danger-transparent me-3">
                      <i className="ti ti-alert-triangle text-danger"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Report a Student</h6>
                      <p className="text-muted mb-0">
                        Disciplinary or cheating
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/document-requests"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-primary-transparent me-3">
                      <i className="ti ti-file-text text-primary"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Document Requests</h6>
                      <p className="text-muted mb-0">Employment proof, slips</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/leave-requests"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-warning-transparent me-3">
                      <i className="ti ti-calendar-off text-warning"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Leave / Absence Requests</h6>
                      <p className="text-muted mb-0">Request time off</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/contact-admin"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-info-transparent me-3">
                      <i className="ti ti-message text-info"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Contact Admin</h6>
                      <p className="text-muted mb-0">Messaging form</p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/report-issues"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-secondary-transparent me-3">
                      <i className="ti ti-tool text-secondary"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Report Technical Issues</h6>
                      <p className="text-muted mb-0">
                        Facility & tech problems
                      </p>
                    </div>
                  </Link>
                </div>
                <div className="col-md-6">
                  <Link
                    to="/teacher/analytics"
                    className="d-flex align-items-center p-3 bg-light rounded text-decoration-none"
                  >
                    <div className="avatar avatar-sm bg-success-transparent me-3">
                      <i className="ti ti-chart-bar text-success"></i>
                    </div>
                    <div>
                      <h6 className="mb-1">Teaching Analytics</h6>
                      <p className="text-muted mb-0">Progress reports</p>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Settings & Support */}
          <div className="card mb-4">
            <div className="card-header">
              <h5 className="card-title mb-0">Settings & Support</h5>
            </div>
            <div className="card-body">
              <Link
                to="/teacher/settings"
                className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
              >
                <div className="avatar avatar-sm bg-primary-transparent me-3">
                  <i className="ti ti-settings text-primary"></i>
                </div>
                <div>
                  <h6 className="mb-1">General Settings</h6>
                  <p className="text-muted mb-0">
                    Notifications, language, theme
                  </p>
                </div>
              </Link>
              <Link
                to="/teacher/help"
                className="d-flex align-items-center p-3 bg-light rounded text-decoration-none mb-3"
              >
                <div className="avatar avatar-sm bg-success-transparent me-3">
                  <i className="ti ti-help text-success"></i>
                </div>
                <div>
                  <h6 className="mb-1">Help / FAQ</h6>
                  <p className="text-muted mb-0">Get support & answers</p>
                </div>
              </Link>
              <button className="btn btn-danger w-100">
                <i className="ti ti-logout me-2"></i>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TeacherMenu;
